
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"#ff4f72","d":"M5.265 13.674v-.761h3.724v.76H5.265zm11.215 1.424v-1.425h-1.47v-.759h1.47v-1.425h.785v1.425h1.469v.76h-1.47v1.424h-.784zM15.18 6h4.361v1.587H22V19H2V7.587h2.459V6h4.36v1.587h6.362V6zm.932 1.588h2.498v-.685h-2.498v.685zm-10.722 0h2.498v-.685H5.39v.685zm-2.46 10.51h18.139V8.49H2.93v9.607z"}}),_c('path',{attrs:{"fill":"#FF4F72","d":"M18.848 8.485a3.636 3.636 0 110-7.273 3.636 3.636 0 010 7.273zm.03-6.06a.455.455 0 00-.454.454V5a.455.455 0 00.91 0V2.879a.455.455 0 00-.455-.455zm-.03 4.666a.515.515 0 100-1.03.515.515 0 000 1.03z"}})])])
          )
        }
      }
    